import React, { useState } from 'react';
import {
  ReactJewishDatePicker,
} from "react-jewish-datepicker";
import "./index.scss";


const HebrewDatePicker = ({
  value = {},
  onChange = () => {},
}) => {
  const [pickerKey, setPickerKey] = useState(Date.now());

  const handleClear = () => {
    onChange({});
    setPickerKey(Date.now());
  };

  return (
    <div className="position-relative">
      <ReactJewishDatePicker
        key={pickerKey}
        value={value?.date ? new Date(value.date) : undefined}
        onClick={onChange}
        className="date-picker__hebrew"
        placeholder={(value?.jewishDateStr && !value?.date) ? value?.jewishDateStr : "Select..."}
      />
      {(value?.date || (value?.jewishDateStr && !value?.date)) && (
        <div className='date-picker__hebrew-clear'
          onClick={handleClear}
        >
          <div className='date-picker__hebrew-clear-icon'>
            ×
          </div>
        </div>
      )}
    </div>
  )
}

export default HebrewDatePicker
